'use client';
import { createStyles, expandResponsive } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var getStyles = function(theme, options) {
    var align = options.align, justify = options.justify, spacing = options.spacing, direction = options.direction, wrap = options.wrap, basis = options.basis, shrink = options.shrink, grow = options.grow;
    return _extends({
        flexDirection: direction,
        flexWrap: wrap,
        flexBasis: basis,
        flexShrink: shrink,
        flexGrow: grow
    }, align && {
        alignItems: align
    }, justify && {
        justifyContent: justify
    }, spacing && {
        gap: theme.fn.space(spacing)
    });
};
var useStyles = createStyles(function(theme, _param) {
    var breakpoints = _param.breakpoints, params = _object_without_properties_loose(_param, [
        "breakpoints"
    ]);
    return {
        root: _extends({
            display: "flex"
        }, getStyles(theme, params), expandResponsive(theme)(breakpoints)(function(params) {
            return getStyles(theme, params);
        }))
    };
});

export { useStyles as default };
